import { Outlet, ScrollRestoration } from "react-router-dom"
import { getMetaContent } from "~/common/get-meta-content"
import { useDocumentTitle } from "~/common/use-document-title"
import { InvitationProvider } from "~/invitation/invitation-context"

export const RootLayout = () => {
  useDocumentTitle(getMetaContent("APP_NAME"))
  return (
    <InvitationProvider>
      <Outlet />
      <ScrollRestoration />
    </InvitationProvider>
  )
}
